import { render, staticRenderFns } from "./AmendTaxSavingsSelectPayaway.vue?vue&type=template&id=247291fc"
import script from "./AmendTaxSavingsSelectPayaway.vue?vue&type=script&lang=js"
export * from "./AmendTaxSavingsSelectPayaway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports